// extracted by mini-css-extract-plugin
export default {"container":"person_container__iX7zC","static":"person_static__HG9uw","staticContent":"person_staticContent__3p2aZ"};